import {config} from '../config';

export default {
    getIsCallUsSection: () =>
        config.data.contactUs.isCallUsSection === undefined ? true : config.data.contactUs.isCallUsSection,
    getMessageUsSection: () => config.data.contactUs.messageUsSection,
    getContactType: () => config.data.contactUs.messageUsSection?.contactType,
};
